import {Button} from '@/components/ui/button/Button'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Menu, MenuItem} from '@/components/ui/menu-atoms/MenuAtoms'
import {Text} from '@/components/ui/text/Text'
import styled, {css} from 'styled-components'

/**
 * Flex items default to `min-width: auto`, so this column would otherwise size to its
 * longest child (e.g. a long email) instead of shrinking to the menu's width, defeating
 * the ellipsis on StyledTruncatedText below.
 */
export const StyledAccountInfo = styled(Flexbox)`
    min-width: 0;
    overflow: hidden;
`

/**
 * Pinned to the neutral palette: wrapping Text in styled() would otherwise instantiate its palette
 * generic to the whole PaletteKey union, narrowing `shade` to the handful of shades every palette
 * shares — which excludes the `black`/`600` this menu uses.
 */
export const StyledTruncatedText = styled(Text<'neutral'>)`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`

/** Fixed-width digits so the button doesn't jiggle every second as the countdown ticks down. */
export const StyledImpersonationCountdown = styled(Text<'warning'>)`
    font-variant-numeric: tabular-nums;
`

/** Impersonating is an abnormal state, so the account button stops looking like the neutral default one. */
export const StyledImpersonationButton = styled(Button)(
    ({theme: {palette}}) => css`
        background-color: ${palette.warning['50']};
        border-color: ${palette.warning['300']};
        &:hover:not(:disabled) {
            background-color: ${palette.warning['100']};
            border-color: ${palette.warning['400']};
        }
        & svg {
            fill: ${palette.warning['700']};
        }
    `
)

export const StyledAccountMenu = styled(Menu)(
    ({theme: {palette, shadows, typography}}) => css`
        background-color: ${palette.neutral.white};
        border-radius: 8px;
        box-shadow: ${shadows.md};
        overflow: hidden;
        width: 280px;
        font-weight: 500;
        color: ${palette.neutral[700]};
        ${typography.textSm};
    `
)

export const StyledMenuItem = styled(MenuItem)(
    ({theme: {spacing, typography, palette}}) => css`
        padding: ${spacing * 2.5}px ${spacing * 3}px;
        min-height: 32px;
        font-weight: 400;
        font-size: ${typography.textSm};
        transition: ease-in-out 200ms;
        color: ${palette.neutral.black};
        &:hover {
            background: ${palette.neutral['100']};
            cursor: pointer;
        }
    `
)
